// extracted by mini-css-extract-plugin
module.exports = {"image":"_2AgUj77b","imageCaption":"_24DdxiXx","isDark":"_1yc4VlV6","isLarge":"_1-0WQpiP"};